import { de as deTranslation, en as enTranslation } from './translations';
import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export enum LanguageCode {
  DE = 'de-DE',
  EN = 'en-US'
}

export const resources = {
  [LanguageCode.DE]: {
    translation: {
      ...deTranslation
    }
  },
  [LanguageCode.EN]: {
    translation: {
      ...enTranslation
    }
  }
};

void i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: LanguageCode.EN,
    keySeparator: false,
    debug: false,
    interpolation: {
      formatSeparator: '.',
      escapeValue: false
    }
  });

export default i18n;

// to be used separated in test
// https://github.com/i18next/i18next/issues/1287#issuecomment-718781261
const t = i18n.t.bind(i18n);
export { t };
